<template>
  <div style="width:100%">
    <el-header  style="margin: 15px" >
      <breadcrumb></breadcrumb>
    </el-header>
    <el-main>
      <Table :tableData.sync="tableData" :showSearch="true" :showEdit="true" :showExport="true" :showImport="true" :showEditButton="true"  
            @sync-delete="deleteSysValueMain" @sync-save="saveSysValueMain" @reload-data-by-sort="reloadDataBySort"/> 
    </el-main>
  </div>
</template>

<script>
import Breadcrumb from "../components/Breadcrumb.vue";
import Table from '../components/EditableTable'

import { apiFindAllSysValueMainData, apiSaveSysValueMainData, apiDeleteSysValueMainDataById } from "../../utils/api.js";
import authHeader from "../../services/auth-header";


export default {
  name: 'sysValueManagement',
  data() {
    return {
      tableData: {
        sel: null,
        columns: [
          { field: "category", title: "Category", width: 250, required:true },
          { field: "enabledStr", title: "Enabled", width: 100 , required:true, type:'select'},
          { field: "description", title: "Description", required:true  }
        ],
        originalTableData:[],
        data: [],
        pagesize: 10,
        currentPage: 1,
        tableId:'sysValueMainTable',
        exportName: this.$i18n.t('menu.sysValueManagement')
      },
      sortColumn:'',
      sortType:'',
    };
  },
  components: {
    Breadcrumb,
    Table
  },
  mounted() {    
    this.readData();
  },
  created(){
      this.tableData.columns.forEach((item) => {
        if(item.field == 'enabledStr'){
          item.selectObj = [{value:'Y',label:'Y'},{value:'N',label:'N'}];
        }
      });
         
  },
  methods: {
    readData(){
      this.tableData.data = [];
      this.tableData.originalTableData =  [];  
      apiFindAllSysValueMainData({ headers: authHeader(), sortColumn:this.sortColumn, sortType:this.sortType  }).then((response) => {  
        response.data.forEach((item, index) => { 
          item.enabledStr = (item.enabled==0?'N':'Y');
        });
        this.tableData.data = response.data;
        this.tableData.originalTableData =  this.tableData.data;    
      }).catch((err) => {
        console.log(err);
      });
    },
    saveSysValueMain(data){
 //debugger
      if(data.length == null){
        data = [data];
      }
      data.forEach((item, index) => { 
        item.enabled = (item.enabledStr=='Y'?1:0);
      });
      apiSaveSysValueMainData({  headers: authHeader(), mainList : data}).then((response) => {                    
        if(response.status == 200){
          this.readData();
          this.$message.success({message: this.$i18n.t('msg.saveSuccess'), duration: 800});
        }else{          
          this.$message.error({message: this.$i18n.t('msg.saveFail'), duration: 1000});
        }           
      
      }).catch((err) => {
        if(err.response.data.message != null && err.response.data.message != ''){
          this.$message.error({message:err.response.data.message, duration: 1000});
        }else{
          this.$message.error({message: this.$i18n.t('msg.saveFail'), duration: 1000});
        }        
        console.log(err);
      });
    },
    deleteSysValueMain(data){           
      apiDeleteSysValueMainDataById({  headers: authHeader(), deleteId : data.id}).then((response) => {               
        if(response.status == 200){
          this.$message.success({message: this.$i18n.t('msg.deleteSuccess'), duration: 800});
        }else{
          this.$message.error({message: this.$i18n.t('msg.deleteFail'), duration: 800});
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    reloadDataBySort(sortColumn, sortType){
      this.sortColumn = sortColumn;
      this.sortType = sortType;
      this.readData()
    } 
  }
};
</script>